export enum DateSlices {
    day = 0,
    month = 1
}